module.exports = __webpack_public_path__ + "img/未开通富信.1af1c88b.png";